import requireContext from 'require-context.macro';
const i18nStrings = requireContext('../', true, /\/strings.json$/);

const i18n = {
	en: Object.assign({}, ...i18nStrings.keys().map(i18nStrings))
}
export default i18n;